import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
//Services
import PacatoxService from '../Rest/pacatox'
import WorkService from '../Rest/work'
import PublisherService from '../Rest/publisher'


Vue.use(Vuex)

let pacatoxService = null;
let workService = null;
let publisherService = null;
export const store = new Vuex.Store({
    state: {
        credit: 0,
        obras: [],
        configs: [],
        loading: false,
        global_alert_showing: { msg: '', tab:0 }, //global para identificar a mensagem que está sendo exibida
        user: {
            token: null, //{access_token,token_type,expires_in}            
            data: {}
        },
        publishers: [],

        //wizards
        wizard: {
            name: null,
            components_zindexed: [],
        }
    },
    plugins: [createPersistedState()],
    getters: {
        global_alert_showing: state => {
            return state.global_alert_showing;
        },
        wizard: state => {
            return state.wizard;
        },
        current_credit: state => {
            let fcredito = state.user.data.artists[0].current_credit;
            return fcredito != null ? fcredito.credit_value : 0 ;
        },
        token: state => {
            return state.user.token ? state.user.token.access_token : null;
        },
        user: state => {
            return state.user.data;
        },
        is_loggedin: state => {
            return state.user.token !== null;
        },
        configs: state => {
            return state.configs;
        },
        obras: state => {
            return state.obras;
        },
        loading: state => {
            return state.loading;
        },
        artist: state => {
            return state.user.data.artists[0];
        },
        composer: state => {
            return state.user.data.composers[0];
        },
        publishers: state => {
            return state.publishers;
        }
    },
    mutations: {
        __global_alert_showing(state, data) {
            if(data == null){
                data = {msg:'',tab:0}
            }
            
            state.global_alert_showing = data
        },
        __wizard(state, wizard) {
            state.wizard = wizard;
        },
        /**
         * Configs
         * @param {*} state 
         * @param {*} configs 
         */
        _configs(state, configs) {
            state.configs = configs;
        },
        /**
        * Atualização das obras
        * @param {Vuex.Store} state 
        */
        _obras_update(state, obras) {
            //@todo verificar se houve alteração antes de recarregar
            state.obras = obras;

        },
        /**
         * Publisher Update
         * @param {Vuex.Store} state 
         */
        _publishers_update(state, publishers) {
            //@todo verificar se houve alteração antes de recarregar
            state.publishers = publishers;

        },
        /**
        * Muda o status de carregando da página
        * @param {*} state 
        */
        loading(state, loading = null) {

            state.loading = loading != null ? loading : !state.loading;
        },
        /**
         * Controla o estado do token
         * @param {*} state 
         * @param {*} val 
         */
        token(state, val = null) {
            state.user.token = val;
        },
        /**
         * Controla o estado usuário
         * @param {*} state 
         * @param {*} data 
         */
        user(state, data = {}) {
            
            if(data.artists[0].members && data.artists[0].members !=null ){
                data.artists[0].members = JSON.parse(data.artists[0].members);           
            }else{
                data.artists[0].members = [];
            }
            state.user.data = data;
        }
    },
    actions: {
        /**
         * Mantém o estado da mensagem global
         * @param {*} context 
         * @param {*} msg 
         */
        global_alert_showing_update(context, data){                        
            this.commit('__global_alert_showing', data);
        },
        /**
         * Chamado quando o usuário é logado
         * @param {*} context 
         * @param {*} data 
         */
        user_authenticate_data(context, data) {
            if (data.token && data.user) {
                this.commit('user', data.user);
                this.commit('token', data.token);
                context.dispatch("pos_login");
            }
        },
        /**
         * Controla o estado do loading full que cobre toda as página
         * @param {*} context 
         */
        loading_full(context, val = true) {
            context.commit("loading", val);
        },
        load_configs(context) {
            pacatoxService = PacatoxService.build();
            pacatoxService.configs().then(e => {
                context.commit("_configs", e.items);
                context.commit("loading", false);
            })
        },
        publishers_update(context, publishers = null) {
            return new Promise((resolve, reject) => {
                publisherService = PublisherService.build();
                publisherService.getAll().then(
                    response => {

                        if (Array.isArray(response.items)) {
                            context.commit("_publishers_update", response.items);
                            context.commit("loading", false);
                            resolve();
                        }
                        else {
                            reject(response);
                        }
                    }
                );


            })
        },
        /**
         * Realiza as funções necessárias para manter o estado das obras atualizado.
         * Há a possibilidade de passar um parametro para obras e atualizar apenas aquela obra
         * ou adicionar um novo.
         * @param {*} context 
         * @param {*} obras 
         */
        obras_update(context, obras = null) {

            return new Promise((resolve, reject) => {
                //sendo obras igual a null recarregamos todo o acervo de obras
                if (obras == null) {

                    context.commit("loading");
                    //recarregamos as obras da API
                    workService = WorkService.build();
                    workService.getAll().then(
                        response => {

                            if (Array.isArray(response.items)) {
                                context.commit("_obras_update", response.items);
                                context.commit("loading", false);
                                resolve();
                            }
                            else {
                                reject(response);
                            }
                        }
                    );
                }
            });
        },
        /**
         * Chamado após o login para carregar as informações que não se alteram ou
         * se alteram pouco
         * @param {*} context 
         */
        pos_login(context) {

            context.dispatch("load_configs");
            context.dispatch("obras_update");
            context.dispatch("publishers_update");

        }
    }
});
